import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  id: PropTypes.string,
};

const MyProfileIcon = ({
  color = '#0D84FE',
  size = 14,
  id = 'my-profile-icon',
  ...props
}) => (
  <svg
    viewBox="0 0 20 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path id={`${id}-a`} d="M0 0h20v20H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use xlinkHref={`#${id}-a`} />
      </mask>
      <path
        d="M18.285 1.702c.918 0 1.662.744 1.662 1.662v13.298c0 .918-.744 1.662-1.662 1.662H1.662A1.662 1.662 0 0 1 0 16.662V3.364c0-.918.744-1.662 1.662-1.662Zm.997 4.322H.665v10.638c0 .551.446.998.997.998h16.623c.55 0 .997-.447.997-.998V6.024Zm-7.979 5.652a2.327 2.327 0 0 1 2.327 2.327v1.994a.332.332 0 0 1-.332.333h-6.65a.332.332 0 0 1-.332-.333v-1.994a2.327 2.327 0 0 1 2.328-2.327Zm-1.33-3.99a1.662 1.662 0 1 1 0 3.325 1.662 1.662 0 0 1 0-3.325Zm-.997-4.322a.665.665 0 1 0 0 1.33.665.665 0 0 0 0-1.33Zm-2.992 0a.665.665 0 1 0 0 1.33.665.665 0 0 0 0-1.33Zm-2.992 0a.665.665 0 1 0 0 1.33.665.665 0 0 0 0-1.33Z"
        fill={color}
        fillRule="nonzero"
        mask={`url(#${id}-b)`}
      />
    </g>
  </svg>
);

MyProfileIcon.propTypes = propTypes;

export default MyProfileIcon;
